const state = {
  userInfo: '' // 用户登陆信息
}
const mutations = {
  setUserInfo (state, payload) {
    state.userInfo = payload
  }
}
const store = {
  namespaced: true,
  state,
  mutations
}
export default store
